export type { EntityNoticeEntryProps } from './entity-notice-entry'
export { EntityNoticeEntry } from './entity-notice-entry'
